import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import './contest.css'; 
import Navigation from '../../components/navigation/Navigation';
import HeaderProfile from "../../components/HeaderProfile";
import PortalAlert from '../../components/portalAlert/portalAlert';
import { getContestList } from '../../store/contest/actions';
import DynamicHTMLRenderer from '../../helpers/dynamicHTMLRenderer'
import { formatDate } from '../../components/common/DateTimeFormatter';
import { getCompanies } from '../../store/employee/actions';
import { hideLoading, showLoading } from '../../store/loading-reducer';
export default function Contest() {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { companiesList } = useSelector(state => state.employee);
    const { siteUserId, primaryCompanyId } = useSelector(state => state.auth);
    const [filter, setFilter] = useState({ query: '', companyId: (primaryCompanyId !== undefined && primaryCompanyId !== null ? primaryCompanyId : 0), sort: 6, userId: siteUserId });

    const { contestAllList } = useSelector(state => state.contest);

    const handleFilterCompany = (e) => {
        const selectedCompanyId = parseInt(e.target.value);
        filter.start = 1;
        setFilter({ ...filter, companyId: selectedCompanyId });
    };

    useEffect(() => {
        document.title = 'Contest | CWP Team Connect';
        dispatch(getCompanies());
    }, []);

    useEffect(() => {
        dispatch(showLoading());
        dispatch(getContestList(filter)).unwrap().then(() => {
            dispatch(hideLoading());
        });
    }, [filter])

    const handleCtaClick = (e, url) => {
        e.stopPropagation();
        if (!url) return;

        url.startsWith('/') ? navigate(url) : window.open(url, '_blank', 'noopener,noreferrer');
    }; 

    return (
        <div className="directory-wrap contest-wrap">
            <div className="drawer-menu-collapse-wrap"></div>
            <Navigation />
            <div className="events-page-wrap">
                <div className="page-inner events-inner">
                    <div className="profile-wrap-outer mobile-show">
                        <HeaderProfile />
                    </div>

                    <div className="events-content-scrollable-wrap">
                        <div className="inner-pages-alert">
                            <PortalAlert />
                        </div>
                        <div className="profile-wrap-outer">
                            <HeaderProfile />
                        </div>
                        <div className="events-header-wrap contest-header-wrap">
                            <div className="events-header-wrap-inner">
                                <div className="marketplace-title-wrapper">
                                    <h1 className="page-title contest-page-title">Contest</h1>  
                                        <div className="filter-bars events-filter">
                                            <label>
                                                <select className="menu-wrap org-dropdown" name="slct" onChange={handleFilterCompany} value={filter.companyId}>
                                                    <option value="0">All</option>
                                                    {companiesList && companiesList.length > 0 &&
                                                        companiesList.map(item => (
                                                            <option key={item.id} value={item.id}>{item.abbreviatedName}</option>
                                                        ))}
                                                </select>
                                            </label>
                                        </div>  
                                </div> 
                            </div>
                        </div>
                        <div className="events-content-wrap contest-item-column-wrap">
                            <div className="contest-listing-wrap">
                                {contestAllList?.length > 0 &&
                                    contestAllList.map((item, index) => {
                                        switch (item?.contestTypeId) {
                                            case 1:
                                                return (
                                                    <span className="contest-listing-item" key={item?.baseId || index}>
                                                        <span className="contest-top-info-wrap">
                                                            <span className="contest-title">{item?.title}</span>
                                                        </span>
                                                        <span className="contest-information-wrap">
                                                            <span className="contest-info-wrap">
                                                                <span className="contest-date">Enter by {item?.createdDate && formatDate(item?.createdDate, "MMM dd")}</span>
                                                            </span>
                                                        </span>
                                                        {item?.ctaText && item?.ctaUrl && <span className="contest-listing-ctatext" onClick={(e) => handleCtaClick(e, item?.ctaUrl)}>{item?.ctaText}</span>}
                                                    </span>
                                                );
                                            case 2:
                                                return (
                                                    <span className="contest-listing-item img-container-wrap" key={item?.baseId || index} >
                                                        <span className="contest-top-info-wrap">
                                                            <span className="contest-title w-100">{item?.title}</span>
                                                            {item?.ctaText && item?.ctaUrl && <span className="contest-listing-ctatext" onClick={(e) => handleCtaClick(e, item?.ctaUrl)}>Enter by {formatDate(item.createdDate, "MMMM dd, yyyy")} {item?.ctaText}</span>}
                                                        </span>
                                                        <span className="contest-information-wrap">
                                                            <span className="contest-information-inner">
                                                                <img className="contest-info-img" src={item?.media?.previewsrc} alt="Contest image one" />
                                                            </span>
                                                            <span className="contest-info-wrap">
                                                                <span className="contest-date"></span>
                                                            </span>
                                                        </span>
                                                    </span>
                                                );
                                            case 3:
                                                return (
                                                    <span className="contest-listing-item winner-wrap" key={item?.baseId || index} >
                                                        <span className="contest-top-info-wrap">
                                                            <span className="contest-title">{item?.title}</span>
                                                        </span>
                                                        <span className="contest-information-wrap">
                                                            <span className="contest-information-inner">
                                                                <span className="contest-winner-title">{item?.subTitle}</span>
                                                            </span>
                                                            <span className="contest-info-wrap">
                                                                <span className="contest-date">{item?.content && DynamicHTMLRenderer(item?.content)}</span>
                                                                {/*<span className="contest-date">15 total reviews in Jan</span>*/}
                                                            </span>
                                                        </span>
                                                    </span>
                                                );
                                            default:
                                                return null;
                                        }
                                    })
                                }
                            </div>
                        </div>
                    </div>

                </div>

            </div>
        </div>

    );
}